module.exports = __webpack_public_path__ + "static/media/back_3.943b8a14.png";